import initCustomSelect from './../../../_global/js/components/customSelect';
import initFileInputs from './../../../_global/js/components/fileInputs';
import validateForm from './../../../_global/js/components/validateForm';



/*
 * barba views
 */
const Job = {
  namespace: 'job',
  beforeEnter: (data) => {
  },
  afterEnter: (data) => {
    initCustomSelect();
    initFileInputs();

    let formsToValidate = document.querySelectorAll('form[data-validate]');
    formsToValidate.forEach(form => validateForm(form, {
    	showErrors: false,
    }));
  }
}

export default Job;
